var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-cascader',{ref:"refCascader",staticStyle:{"width":"400px"},attrs:{"placeholder":"请选择服务单类型","options":_vm.productTypeSlectOption,"size":"200","value":_vm.productTypeUidSelected,"defaultValue":_vm.defaultValue,"filterable":""},on:{"change":function($event){return _vm.change(_vm.productTypeUidSelected)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }